import React, { useEffect, useState } from 'react';
import useSWR from 'swr';

import AssayCreationButton from '../../../assays/AssayCreationButton';
import CardHeader from '../../../common/Labels/CardHeader';
import CardView from '../../../common/CardView/CardView';
import Label from '../../../common/Labels/Label';
import PipelineAssayChartList from '../../../assays/PipelineAssayChartList/PipelineAssayChartList';

import { swrAssayBaselineFetcher } from '../../../../utils/api_functions/assayBaselineFetch';
import useClientContext from '../../../contexts/ClientData/ClientData';
import usePipelineData from '../../PipelineDataContext';
import { usePipelineEdgeData } from '../../../VersionHistoryTimeline/PublishPipelineContext';
import useWorkspaceContext from '../../../workspaces/WorkspaceContext/WorkspaceContext';

export const PipelineInsightsTab = () => {
  const { pipeline } = usePipelineData();
  const { isEdgeEnabled } = useClientContext();
  const { selectedEdgeLocations } = usePipelineEdgeData()
  const { currentWorkspaceId } = useWorkspaceContext();
  const [singleInference, setSingleInference] = useState(null);

  const numberOfSelectedEdges = selectedEdgeLocations?.length || 0;
  const selectedEdgeNames = selectedEdgeLocations?.length ? selectedEdgeLocations.map(({ name }) => name) : [];

  // Previously wouldn't allow for rechecking if one inference was obtained
  // Now this logic is removed to allow for location changes
  const pipelineID = pipeline?.pipelineID;
  const queryArgs = [pipelineID, currentWorkspaceId, 1, selectedEdgeNames]
  const queryKey = `assay-min-inference-check-${pipelineID}`
  const {
    data,
  } = useSWR(queryKey, () => swrAssayBaselineFetcher(queryArgs), { refreshInterval: 5000 })

  useEffect(() => {
    if (!data) {
      return;
    }

    // clone keeps the stream healthy for rereads - needed for this effect block
    data.clone().json().then((data_json) => {
      if (!data_json.length) {
        setSingleInference(null);
      } else {
        setSingleInference(data_json[0]);
      }
    });
  }, [data])

  return (
    <CardView>
      <div className="flex justify-between items-center text-center mb-2">
        <CardHeader className="mb-2">Assays</CardHeader>
        <AssayCreationButton disable={singleInference === null} inferenceData={singleInference}/>
      </div>
      {
        isEdgeEnabled && numberOfSelectedEdges > 0 && (
          <Label>Showing assays that include at least one of the filtered edges</Label>
        )
      }
      <PipelineAssayChartList />
    </CardView>
  )
}

export default PipelineInsightsTab;
